var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gift"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/gift"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gift_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M19.9702 10V18C19.9702 21 18.9702 22 15.9702 22H7.97021C4.97021 22 3.97021 21 3.97021 18V10H19.9702Z",
    fill: "#4037acd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.5 7V8C21.5 9.1 20.97 10 19.5 10H4.5C2.97 10 2.5 9.1 2.5 8V7C2.5 5.9 2.97 5 4.5 5H19.5C20.97 5 21.5 5.9 21.5 7Z",
    fill: "#4037acd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M11.6398 4.99994H6.11978C5.77978 4.62994 5.78978 4.05994 6.14978 3.69994L7.56978 2.27994C7.93978 1.90994 8.54978 1.90994 8.91978 2.27994L11.6398 4.99994Z",
    fill: "#4037acd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M17.8701 4.99994H12.3501L15.0701 2.27994C15.4401 1.90994 16.0501 1.90994 16.4201 2.27994L17.8401 3.69994C18.2001 4.05994 18.2101 4.62994 17.8701 4.99994Z",
    fill: "#4037acd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.6,
    d: "M8.93994 10V15.14C8.93994 15.94 9.81994 16.41 10.4899 15.98L11.4299 15.36C11.7699 15.14 12.1999 15.14 12.5299 15.36L13.4199 15.96C14.0799 16.4 14.9699 15.93 14.9699 15.13V10H8.93994Z",
    fill: "#4037acd6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIconBlue);
export default __webpack_public_path__ + "static/media/gift_icon_blue.f9cfcb3a7b4f0f3f6cf8028c09fa9729.svg";
export { ForwardRef as ReactComponent };